import axios from 'axios'
import defaultSettings from '../modules/config/defaultSettings'
import { Message } from 'element-ui'

export const Axios = axios.create({
  // baseURL: rootUrl(),
  baseURL: "/api",
  timeout: defaultSettings.apiTimeout
})

// 在发送请求之前做某件事
Axios.interceptors.request.use(config => {
  var headers = {
    // 携带token
    tokenId: sessionStorage.getItem('tokenId2') || "",
    userId: localStorage.getItem('userId') || "",
    // 携带UUID
    uuid: sessionStorage.getItem('uuid') || "",
    ...config.headers
  }

  for (const key in headers) {
    config.headers[key] = headers[key]
  }

  return config
}, error => {
  return Promise.reject(error)
})

// 返回状态判断(添加响应拦截器)
Axios.interceptors.response.use(res => {
  // 授权失败
  if (res.data.status == 401) {
    sessionStorage.setItem('tokenId2', '')
    window.location.href = defaultSettings.bscLoginUrl
  }
  // 根据status拦截异常
  if (res.data.status == -1) {
    // Message({
    //   message: res.data.msg,
    //   type: 'error',
    //   duration: 5 * 1000
    // })
  }
  console.log(res)
  return res
}, error => {
  let errorMsg = ''
  if (error.message.includes('timeout')) {
    errorMsg = '请求超时!'
  } else {
    errorMsg = '请求异常!'
  }
  Message({
    message: errorMsg,
    type: 'error',
    duration: 5 * 1000
  })
  console.log(error.message)
  console.log(defaultSettings.bscLoginUrl)
  // window.location.href = defaultSettings.bscLoginUrl
  return Promise.resolve({ status: -1, Success: false, Msg: errorMsg })
})
export default {
  install(Vue) {
    Object.defineProperty(Vue.prototype, '$http', { value: Axios })
  }
}
